(function () {

    'use strict';

    angular
        .module('corporateRoleEditModule')
        .controller('CorporateRoleEditController', Controller);

    Controller.$inject = ['$scope', 'topBarService', 'corporateRole'];

    function Controller($scope, topBarService, corporateRole) {

        topBarService.setTitleAndIcon('Edit Corporate Role', 'fa fa-tags');
        $scope.corporateRole = corporateRole;

    }
})();